var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"percentile"},_vm._l((_vm.bars),function(bar,index){return _c('div',{key:index,staticClass:"percentile-item"},[_c('div',{staticClass:"percentile-item-bar",class:{'is-active': index === _vm.value.index},style:(bar.style)})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }